<template>
  <div class="title-area" :class="{ noBorder: dense }">
    <div class="title-text">{{ text }}</div>
    <div class="close-wrapper">
      <div v-if="showReturn" class="close return" @click="clickClose">
        <img class="chev" src="@/assets/chevron-green.svg" />戻る
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "title-area",
  components: {},
  props: {
    text: { type: String },
    showReturn: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
  },
  computed: {},
  methods: {
    clickClose() {
      if (this.showReturn) {
        this.$emit("click-close");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.title-area {
  position: fixed;
  top: 0;
  width: 100%;
  border-bottom: #cdcdcd 1px solid;
  margin: 0;
  text-align: center;
  padding: 0.3rem 0rem;
  background: white;
  z-index: 0;
  &.noBorder {
    padding: 0.2rem 0em;
    border-bottom: none;
  }
  .close-wrapper {
    position: absolute;
    display: flex;
    top: 0;
    width: 5rem;
    height: 2rem;

    .close {
      position: absolute;
      font-weight: bold;
      font-size: 1rem;
      left: 0.25rem;
      top: 0.4rem;
      color: #5cd5d6;
      display: flex;
      align-items: center;
      .chev {
        height: 0.55rem;
        margin-right: 0.25rem;
        transform: rotate(90deg);
      }
    }
  }

  .title-text {
    font-size: 1rem;
    font-weight: 700;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Atoms/TitleArea.vue